import * as React from "react";
import { withTranslation } from "react-i18next";
import { Button, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { StyledModal } from "./StyledModal";
import i18n from "../../i18n";

export type ImportedPeriodSummary = {
  period: string;
  invoiceCount: number;
  rowCount: number;
};

interface ProjectImportSuccessModalProps {
  selectedPeriod: string;
  periods: ImportedPeriodSummary[];
  onDismiss: () => void;
  onSelectPeriod: (period: string) => void;
}

class ProjectImportSuccessModal extends React.Component<ProjectImportSuccessModalProps> {
  private getCurrentPeriodCount = (): number => {
    return (
      this.props.periods.find(
        (item) => item.period === this.props.selectedPeriod,
      )?.invoiceCount ?? 0
    );
  };

  render() {
    const currentPeriodCount = this.getCurrentPeriodCount();

    return (
      <StyledModal
        headerStyle={{
          backgroundColor: "#173c53",
          color: "white",
        }}
        title={i18n.t("kickbackProject.importSuccess").toString()}
        onDismiss={this.props.onDismiss}
        body={
          <div>
            <p style={{ fontSize: 16 }}>
              {i18n.t("kickbackProject.importSuccessDescription")}
            </p>

            {currentPeriodCount === 0 && (
              <div
                style={{
                  marginBottom: 20,
                  padding: 14,
                  borderLeft: "5px solid rgb(245, 156, 47)",
                  backgroundColor: "rgba(245, 156, 47, 0.08)",
                }}
              >
                <Stack direction="horizontal" gap={2}>
                  <FontAwesomeIcon
                    icon="triangle-exclamation"
                    style={{
                      color: "rgb(245, 156, 47)",
                      fontSize: "1.3rem",
                    }}
                  />

                  <div>
                    <strong>
                      {i18n.t("kickbackProject.importNoRowsCurrentPeriod")}
                    </strong>

                    <div style={{ marginTop: 4 }}>
                      {this.props.selectedPeriod}
                    </div>
                  </div>
                </Stack>
              </div>
            )}

            <Stack gap={3}>
              {this.props.periods.map((item) => {
                const isCurrentPeriod =
                  item.period === this.props.selectedPeriod;

                return (
                  <div
                    key={item.period}
                    style={{
                      padding: 16,
                      borderLeft: isCurrentPeriod
                        ? "5px solid #173C53"
                        : "5px solid #8FA9BA",
                      backgroundColor: "rgba(143, 169, 186, 0.08)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 16,
                        flexWrap: "wrap",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: 17,
                            fontWeight: 700,
                            color: "#173C53",
                          }}
                        >
                          {item.period}
                        </div>

                        <div
                          style={{
                            marginTop: 6,
                            fontSize: 14,
                          }}
                        >
                          <strong>{item.invoiceCount}</strong>{" "}
                          {i18n.t(
                            item.invoiceCount === 1
                              ? "kickbackProject.invoice"
                              : "kickbackProject.invoices",
                          )}
                          {item.rowCount !== item.invoiceCount && (
                            <>
                              {" · "}
                              <strong>{item.rowCount}</strong>{" "}
                              {i18n.t(
                                item.rowCount === 1
                                  ? "kickbackProject.articleRow"
                                  : "kickbackProject.articleRows",
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      {!isCurrentPeriod && (
                        <Button
                          style={{
                            color: "rgb(23, 61, 84)",
                          }}
                          className="button button-submit"
                          onClick={() => this.props.onSelectPeriod(item.period)}
                        >
                          <FontAwesomeIcon
                            icon="arrow-right"
                            style={{ marginRight: 6 }}
                          />

                          {i18n.t("kickbackProject.goToPeriod")}
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })}
            </Stack>

            <div
              style={{
                marginTop: 20,
                fontSize: 13,
                color: "#64748b",
              }}
            >
              {i18n.t("kickbackProject.importPeriodsReportedSeparately")}
            </div>
          </div>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button
              className="button button-cancel"
              onClick={this.props.onDismiss}
            >
              {i18n.t("general.close")}
            </Button>
          </div>
        }
      />
    );
  }
}

export default withTranslation()(ProjectImportSuccessModal);
